// extracted by mini-css-extract-plugin
module.exports = {"container":"Quote_container__gTdcr","row":"Quote_row__syW3D","image":"Quote_image__OhElJ","text":"Quote_text__zlAg9","author":"Quote_author__wdhRw","quote":"Quote_quote___hvUk"};